import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable, forkJoin } from 'rxjs';
import { ProjectApiModel } from 'app/models/projects-api.model';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwLoadOptionsService } from './utils/load-options.service';
import { MwPayloadModel } from 'app/models/payload.model';

@Injectable()
export class MwProjectsApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  private apiEndpoint = '/integration/v1/Companies/{companyId}/Projects';

  getProjects(
    loadOptions?: MwLoadOptions
  ): Observable<MwPayloadModel<ProjectApiModel[]>> {
    let params = loadOptions
      ? this.loadOptionsService.buildQuery(loadOptions)
      : '';

    if (params) {
      params = '?' + params;
    }

    return this.http.authGet<MwPayloadModel<ProjectApiModel[]>>(
      `${this.apiEndpoint}${params}`
    );
  }

  createProject(project: ProjectApiModel): Observable<ProjectApiModel> {
    return this.http.authPost<ProjectApiModel>(this.apiEndpoint, {
      body: project,
    });
  }

  updateProject(project: ProjectApiModel): Observable<any> {
    return this.http.authPut<ProjectApiModel>(this.apiEndpoint, {
      body: project,
    });
  }

  deleteProject(project: ProjectApiModel): Observable<ProjectApiModel> {
    return this.http.authDelete<ProjectApiModel>(this.apiEndpoint, {
      body: project,
    });
  }

  deleteProjectsList(projects: ProjectApiModel[]): Observable<any> {
    return forkJoin(
      projects.map((project) =>
        this.http.authDelete<ProjectApiModel[]>(this.apiEndpoint, {
          body: project,
        })
      )
    );
  }
}
